<template>
  <div class="container">
    <h1>Live-Album</h1>
    <sync-form v-bind="formdata" v-on:ok="ok">
      <p>Gib das Passwort aus deinem Booklet ein:</p>
      <label for="download_password">Passwort</label>
      <input v-model="download_password">        
    </sync-form>
    <p v-show="link">
      Der Download sollte automatisch gestartet haben. Falls nicht, klicke <a ref="downloadLink" :href="link" target="_blank" rel="noopener">hier</a>.
    </p>
  </div>
</template>

<script>
import SynchronousForm from '@/components/Generic/SynchronousForm'

export default {
  name: 'LiveAlbumPage',
  components: {
    'sync-form': SynchronousForm
  },
  data: function () {
    return {
      download_password: '',
      link: null,
    }
  },
  methods: {
    ok: function (data) {
      this.link = data;
      this.$nextTick(() => {
        this.$refs.downloadLink.click();
      });
    },
  },
  computed: {
    formdata: function () {
      return {
        endpoint: '/download/live-album',
        submitText: 'Download starten',
        payload: '"' + this.download_password + '"',
      }
    },
  }
}
</script>

<style scoped>

form {
  border-radius: 0.6em;
  border: 1px solid grey;
}

.container > form {
  min-width: 10em;
  max-width: 20em;
  background-color: rgba(0, 0, 0, 0.1);
  padding: 1em;
  margin-bottom: 1em;
}
</style>
